import React, { useState, useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import ProblemSection from '../components/ProblemSection';
import SolutionSection from '../components/SolutionSection';
import FeaturesGrid from '../components/FeaturesGrid';
import AIEngineSection from '../components/AIEngineSection';
import DashboardPreview from '../components/DashboardPreview';
import RewardsPreview from '../components/RewardsPreview';
import WhyQykfinSection from '../components/WhyQykfinSection';
import WaitlistSection from '../components/WaitlistSection';
import Footer from '../components/Footer';
import WaitlistDialog from '../components/WaitlistDialog';

const LandingPage = () => {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    // Check if user has already seen the dialog
    const hasSeenDialog = sessionStorage.getItem('qykfin_dialog_seen');
    
    if (!hasSeenDialog) {
      // Show dialog after a short delay for better UX
      const timer = setTimeout(() => {
        setShowDialog(true);
      }, 2000); // 2 seconds delay
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleCloseDialog = () => {
    setShowDialog(false);
    sessionStorage.setItem('qykfin_dialog_seen', 'true');
  };

  return (
    <div className="min-h-screen bg-white font-inter overflow-x-hidden">
      {/* Waitlist Dialog */}
      {showDialog && <WaitlistDialog onClose={handleCloseDialog} />}
      
      {/* 1. Hero - AI Financial Co-Pilot */}
      <HeroSection />
      
      {/* 2. Problem - Why People Lose Money */}
      <ProblemSection />
      
      {/* 3. Solution - How Qykfin Fixes This */}
      <SolutionSection />
      
      {/* 4. Features - Core Capabilities Grid */}
      <FeaturesGrid />
      
      {/* 5. AI Engine - Intelligence Section */}
      <AIEngineSection />
      
      {/* 6. Dashboard Preview */}
      <DashboardPreview />
      
      {/* 7. Rewards Preview */}
      <RewardsPreview />
      
      {/* 8. Why Qykfin - Comparison */}
      <WhyQykfinSection />
      
      {/* 9. Waitlist CTA */}
      <WaitlistSection />
      
      {/* 10. Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
